module.exports = __webpack_public_path__ + "static/media/model5.2f458961.jpg";